import * as React from "react";

const CustomLightningBoltIcon: React.FC = () => {
    return (
        <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.93843 1.04549C8.07668 0.724405 7.97358 0.349418 7.69004 0.143176C7.40651 -0.063067 7.01988 -0.0443176 6.75509 0.185362L0.756385 5.43518C0.522061 5.64142 0.437704 5.97188 0.547836 6.26249C0.657969 6.55311 0.939158 6.74997 1.25081 6.74997H3.86353L2.06157 10.9545C1.92332 11.2756 2.02642 11.6506 2.30996 11.8568C2.59349 12.0631 2.98012 12.0443 3.24491 11.8146L9.24362 6.56482C9.47794 6.35858 9.5623 6.02812 9.45216 5.73751C9.34203 5.4469 9.06318 5.25237 8.74919 5.25237H6.13647L7.93843 1.04549Z"
                fill="#0F96D9"
            />
        </svg>
    );
};

export default React.memo(CustomLightningBoltIcon);
